import React from "react";

import AIPlanner from "./aiPlanner";

const AIPowered: React.FC = () => {
  return (
    <>
      <div className="text-white w-full md:px-6 sm:px-4 px-0 flex flex-col lg:items-end justify-center">
        <div className="flex flex-col justify-center lg:w-full xl:w-auto bg-red-0">
          <h1 className="scale-95 md:scale-100 xl:text-9xl lg:text-8xl md:text-[80px] text-[70px] font-bold">
            Endless <br /> Travel.
          </h1>
          <p className="scale-95 md:scale-100 md:text-[24px] text-[20px] lg:text-[22px] xl:text-[28px] font-bold md:mt-3.5 mt-0 md:mb-10 lg:mb-14 mb-9">
            Plan your next adventure
          </p>
          {/* <div className="flex items-center gap-x-2 bg-white rounded-full xl:min-w-[540px] lg:w-[480px] md:max-w-[80%] sm:max-w-[90%]">
            <input
              // type="text"
              className="w-full lg:px-5 xl:px-7 px-5 md:py-[18px] py-4 lg:py-4 xl:py-6 rounded-full outline-none font-semibold lg:text-lg xl:text-xl text-base text-black placeholder:text-[#898989]"
              placeholder="Tell me where you plan to go!"
            />
            <button className="md:mr-2 mr-1.5 flex-shrink-0 bg-black rounded-full lg:p-2.5 xl:p-4 p-2">
              <span className="xl:scale-150 lg:scale-125 flex items-center justify-center">
                <SendIcon />
              </span>
            </button>
          </div> */}
          <AIPlanner />
        </div>
      </div>
    </>
  );
};

export default AIPowered;
